// Routes owned by the Operations module. Merged into the app-wide `paths`
// object by src/app/paths.ts; see src/modules/README.md.
export const operationsPaths = {
    operationsDashboard: '/operations',
    operationsServices: '/operations/services',
    operationsServiceDetail: '/operations/services/:id',
    operationsResources: '/operations/resources',
    operationsCdn: '/operations/cdn',
    operationsOrgs: '/operations/orgs',
    operationsOrgDetail: '/operations/orgs/:orgId',
} as const
